import { TableFooter } from '@nexelem/deprecated-theme';
import { useTableContext } from '../../../hooks/useTableContext';
import { useTranslation } from 'react-i18next';
import { useGridRootProps } from '@mui/x-data-grid-pro';
import { TableLegendProps } from '../../../context/types';
import { FC } from 'react';
import { MultiselectFooter, MultiselectFooterProps } from './MultiselectFooter';

export type FooterProps = MultiselectFooterProps & {
  TableLegend?: FC<TableLegendProps>;
};

export const Footer = ({ TableLegend, MultiSelectFooterProps, withCancel }: FooterProps) => {
  const { isMultiselect, selectionModel, keepPagination } = useTableContext();
  const { rowCount = 0, rows } = useGridRootProps();
  const { t } = useTranslation();

  const isMultiselectFooterVisible = selectionModel.size && isMultiselect && !keepPagination;

  return (
    <TableFooter
      className="box-border flex min-h-15 border-t border-border-primary bg-surface-secondary px-8 text-s11-sb text-text-secondary-darker uppercase"
      component="div"
    >
      <div className="flex w-full items-center">
        <div className="flex flex-1 items-center">
          {isMultiselectFooterVisible ? (
            <MultiselectFooter MultiSelectFooterProps={MultiSelectFooterProps} withCancel={withCancel} />
          ) : (
            <>
              {rows.length} {t('components.table.footer.of')} {rowCount}
            </>
          )}
        </div>
        <div className="flex flex-2 items-center justify-center">{TableLegend && <TableLegend rows={rows} />}</div>
        <div className="flex-1"></div>
      </div>
    </TableFooter>
  );
};
